var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEndUserComputing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 176,
    height: 176,
    viewBox: "0 0 176 176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "End_User_Computing",
    "data-name": "End User Computing",
    transform: "translate(0.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 88,
    cy: 88,
    r: 88,
    transform: "translate(-0.433)",
    fill: "rgba(214,233,255,0.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 75.3,
    cy: 75.3,
    r: 75.3,
    transform: "translate(12.7 12.7)",
    fill: "#d1e6ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10638",
    "data-name": "Group 10638",
    transform: "translate(27 27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10637",
    "data-name": "Group 10637"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 61,
    cy: 61,
    r: 61,
    transform: "translate(-0.433)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "devices_black_24dp_3_",
    "data-name": "devices_black_24dp (3)",
    transform: "translate(54.567 55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3626",
    "data-name": "Path 3626",
    d: "M0,0H66.066V66.066H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3627",
    "data-name": "Path 3627",
    d: "M18,10H29.011V29.269H18Z",
    transform: "translate(31.55 17.528)",
    fill: "#d6e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3628",
    "data-name": "Path 3628",
    d: "M63.313,15.011H46.8a2.761,2.761,0,0,0-2.753,2.753V45.291A2.761,2.761,0,0,0,46.8,48.044H63.313a2.761,2.761,0,0,0,2.753-2.753V17.764A2.761,2.761,0,0,0,63.313,15.011ZM60.561,39.786H49.55V20.517H60.561ZM11.011,9.506h49.55V4H11.011A5.522,5.522,0,0,0,5.506,9.506v30.28H0v8.258H38.539V39.786H11.011Z",
    transform: "translate(0 7.011)",
    fill: "#12355f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndUserComputing);
export default __webpack_public_path__ + "static/media/End User Computing.04c0ea5d73174b01425ca0c354ee6c57.svg";
export { ForwardRef as ReactComponent };